import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function PriceList() {
  useSEO(seoConfig.priceList);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetch("/files/price.xlsx") // файл должен лежать в files/
      .then((res) => res.arrayBuffer())
      .then((data) => {
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0]; // берём первый лист
        const sheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // массив массивов
        setRows(json);
      });
  }, []);

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Прейскурант на медицинские услуги ГБУ СО УрНИИДВиИ
      </h1>

      {/* <div className="price-table-wrapper" style={{ overflowX: "auto" }}> */}
      <table className="price-table contacts__table first_table">
        <tbody>
          {rows.map((row, rowIndex) => {
            // Первая строка = заголовки
            if (rowIndex === 0) {
              return (
                <tr className="contacts__line header-row" key={rowIndex}>
                  {row.map((cell, colIndex) => (
                    <th className="contacts__cell second_cell" key={colIndex}>
                      {cell}
                    </th>
                  ))}
                </tr>
              );
            }

            // Остальные строки
            return (
              <tr className="contacts__line" key={rowIndex}>
                {row.map((cell, colIndex) => {
                  const cellText = String(cell || "");
                  let bold = false;

                  // Проверяем предыдущую ячейку
                  if (colIndex > 0) {
                    const prevCellText = String(row[colIndex - 1] || "");
                    if (prevCellText.endsWith(" ")) {
                      bold = true;
                    }
                  }

                  return (
                    <td
                      className={`contacts__cell second_cell ${
                        bold ? "bold-cell" : ""
                      }`}
                      key={colIndex}
                    >
                      {cellText}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* </div> */}
    </section>
  );
}
